
const init = () => {
    var $banner = $('.banner');
    if ($banner.length < 1) return;
    

    var desatElHeight;
    var desatElOffsetTop
    var $desatEl;
    var hasTweeningBanner = false;
    var $win = $(window);

    if ($banner.hasClass('banner--bg')) {
        hasTweeningBanner = true;

        desatElHeight = $banner.height();
        desatElOffsetTop = $banner.offset().top;

        var throttledScroll = _.throttle(onScroll, 100, { trailing: true });
        //$(window).on('scroll', throttledScroll);

        function onScroll() {
            var scrolledPx = $win.scrollTop();
            var pixelsScrolled = scrolledPx - desatElOffsetTop;
            var percScrolled = Math.floor((pixelsScrolled / desatElHeight) * 120);
            var inversed = 100 - percScrolled;

            
            
            

            // bounds
            if (inversed > 100) {
                inversed = 100;
            } else if (inversed < 0) {
                inversed = 0;
            }

            
            
            $banner.css({
                webkitFilter: 'saturate(' + inversed + '%)',
                filter: 'saturate(' + inversed + '%)'
            });
        }
    }

    //
    // look inside
    //
    var $lookInsideLeaf = $('.banner__look-inside');
    var $lookInsideCover = $('.banner__magnify');
    
    var $lookInside = $('.page-content > .look-inside');
    var viewer;

    PubSub.subscribe('app:resized', function(msg, breakpoint) {

        if (hasTweeningBanner) {
            desatElHeight = $banner.height();
            desatElOffsetTop = $banner.offset().top;
        }

        var widthMod = 0.87;
        var heightMod = 0.87;

        $lookInside
            .width(window.app.state.winWidth * widthMod)
            .height(window.app.state.winHeight * heightMod);
        if (viewer) viewer.resize();
    });

    // book page 'Hi-Res Cover' link
    $('.banner__download-cover').click(function(e) {
        e.preventDefault();
        var lightbox = penguinModal($(this).attr('href'));
    });

    $lookInsideCover.click(function(e) {

        if ($(document.body).hasClass('author-page')) {
            e.preventDefault();
            var lightbox = penguinModal($(this).attr('href'));
        }

        if ($lookInsideLeaf.length < 1 || $lookInsideCover.hasClass('is-disabled')) return;
        $lookInsideLeaf.click();
    })
    $lookInsideLeaf.click(function(e) {
        e.preventDefault();

        // check
        if (!$lookInsideLeaf.attr('data-isbns')) return;

        var isbns = _.map($lookInsideLeaf.data('isbns'), function(isbn) {
            return 'ISBN:' + isbn;
        });  
        
        // Ensure Google Books API is loaded before creating viewer
        if (typeof google === 'undefined' || typeof google.books === 'undefined' || typeof google.books.DefaultViewer === 'undefined') {
            console.warn('Google Books API not loaded yet');
            return;
        }

        if (typeof viewer === 'undefined') {
            try {
                viewer = new google.books.DefaultViewer($lookInside.get(0));
                viewer.load(isbns, function() {
                    // Success callback
                }, function() {
                    // Error callback
                });
            } catch (error) {
                console.error('Error creating Google Books viewer:', error);
            }
        }
        var lightbox = penguinModal($lookInside);
    });

    //
    // hi-res cover link removal 
    //
    if ($lookInsideCover.length > 0) {
        var src = $lookInsideCover.find('img').attr('src');
        if (src.indexOf('not-found') !== -1) {
            $banner.find('.banner__download-cover').hide();
        }
    }

}

export default init;
